<script>
import AdminLayout from '@layouts/admin-main'
import AccountList from '@components/admin/account-list'
import AccountCatalogNav from '@components/admin/account-catalog-nav'

export default {
  page: {
    title: 'Admin::AccountList',
    meta: [{ name: 'description', content: 'Admin::AccountList' }],
  },
  components: { AdminLayout, AccountList, AccountCatalogNav },
}
</script>

<template>
  <AdminLayout>
    <AccountCatalogNav></AccountCatalogNav>
    <AccountList></AccountList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
